import { render, staticRenderFns } from "./JoinFalse.vue?vue&type=template&id=ad0d292e"
import script from "./JoinFalse.vue?vue&type=script&lang=js"
export * from "./JoinFalse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports